import { OverviewContainer, OverviewHighlightText } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
export const InsightsReportSettingsHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                <b>Insights Report Settings</b> allow you to edit details about the report, such as the name, description, and add a logo. It also allows you to manage the project groups and environments groups used within the report.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
